import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { SnackbarService } from '../../../../../core/services/snackbar.service';

@Component({
    selector: 'app-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.css'],
})
export class DeleteDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<DeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: SnackbarService
    ) {}

    onNoClick(): void {
        this.dialogRef.close({ deleted: false });
    }

    confirmDelete(): void {
        this.data.dataService.delete(this.data.id).subscribe(
            () => {
                this.dialogRef.close({ deleted: true });
            },
            (err) => {
                if (err.status === 409) {
                    this.snackBar.info(
                        'Nie można usunąć wybranego koszyka, ponieważ jest używany w symulacji.'
                    );
                } else if (err.status !== 403) {
                    this.snackBar.info('Nie udało się usunąć instancji.');
                }
                this.dialogRef.close({ deleted: false });
            }
        );
    }
}
